import { useState, useReducer, useEffect, useMemo } from "react";
import ContentReceiver from "../../../ContentReceiverNewBrowserTab/ContentReceiver";
import OpenQuickPopup from "../../../../shared/OpenQuickPopup/OpenQuickPopup";
import CustomUseRef from "../../../../shared/DropDown/CustomUseRef";
import PatientPayments from "../../../../shared/PatientPayments/PatientPayments";
import AddNewInsurancePayment from "./AddNewInsurancePayment";
import { useDispatch, useSelector } from "react-redux";
import { IconClaimMenu, IconResumeAiSession } from "../../../../shared/IconsComponent/icons";
import InstantEligibility from "../../../../Patient/PatientInstantEligibility/InstantEligibility";
import EncounterMenu from "../../../../Encounter Menu/EncounterMenu";
import { MainTabContentActiveTab, MainTabContentTabList } from "../../../../../actions/SidebarAction";
import { TabActionEncounterMenu } from "../../../../../actions/EncounterMenuActions";
import ResumeAISession from "../../../../../actions/ResumeAISession";
import { AddPatientToDropDowns } from "../../../../../actions/GeneralPatientActions";
// import Addalert from "../../General/AddAlert";
// import FormValidator from "../../../../../utils/FormValidator";
// import { enumUtil } from "../../../../../utils/Enum";
// import NotificationHandler from "../../../../../utils/NotificationHandler";
// import { ServerRequestProtected } from "../../../../../utils/ServerDataRequest";
// import Modal from 'react-bootstrap/Modal';
// import DatePicker from "../../../../General/DatePicker";
// import handleNumericCheck from "../../../../../utils/HandleNumericKeys";
// import format from 'date-fns/format';
// import ModalHeader from "../../../../Setup/Shared/ModalHeader";
// import SuperSearchList from "../../../../shared/SuperSearch/SuperSearchList";
// import isNull from "../../../../../utils/NullChecking";
// import { TabActionPayments } from "../../../../../actions/BillingActions";
// import { FindSecondChild } from "../../../../../utils/FindMenuOption";
const QuickAddMenu = () => {
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const isHomeCareCheck = DropDowns.IsHomeCare
    // const API_URL = enumUtil.controller.Payment
    // let IsEditAllowedInurancePayment = FindSecondChild('Billing', 'Payments', 'Add Insurance Payment')?.IsAdd
    const [isOpenInstantEligibility, setIsOpenInstantEligibility] = useState(false);

    const handleOpenInstantElibility = () => {
        console.log('here handleOpenInstantElibility');

        setIsOpenInstantEligibility(true)
    }
    const handleCloseInstantElibility = () => {
        setIsOpenInstantEligibility(false)
    }
    let InstantEligibilityPopup = ""

    if (isOpenInstantEligibility) {
        InstantEligibilityPopup = <InstantEligibility isOpenInstantEligibility={isOpenInstantEligibility} CloseInstantElibility={handleCloseInstantElibility} />
    }
    const OPTIONS = [
        {
            name: 'AddPatient',
            elem:
                <li className='d-flex gap-2  align-items-center cursor-pointer px-10 py-2px selection-hover' onClick={() => handleObjData("Patient", "Patient")}>
                    <span className='icon'>
                        <i className='icon-PATIENTT fs-12 lh-12'></i>
                    </span>
                    <span className='heading'>
                        Add Patient
                    </span>
                </li>
        },
        ...(isHomeCareCheck === 'true' ? [] : [
            {
                name: 'Add Appointment',
                elem:
                    <li className='d-flex gap-2  align-items-center cursor-pointer px-10 py-2px selection-hover'>
                        <span className='icon'>
                            <i className='icon-SCHEDULER fs-11 lh-11'></i>

                        </span>
                        <span className='heading' onClick={() => handleOpenQuickPopup("Appointment", "Individual")}>
                            Add Appointment
                        </span>
                    </li>
            }]),

        ...(isHomeCareCheck === 'true' ? [] : [
            {
                name: 'Add Appointment',
                elem:
                    <li className='d-flex gap-2  align-items-center cursor-pointer px-10 py-2px selection-hover'>
                        <span className='icon'>
                            <i className='icon-SCHEDULER fs-11 lh-11'></i>

                        </span>
                        <span className='heading' onClick={() => handleOpenQuickPopup("Appointment", "Group")}>
                            Add Group Appointment
                        </span>
                    </li>
            }]),
        {
            name: 'Add Professional Claim',
            elem:
                <li className='d-flex gap-2  align-items-center cursor-pointer px-10 py-2px selection-hover' onClick={() => handleObjData("Claims", "Professional Claims")}>
                    <span className='icon'>
                        <IconClaimMenu classes={'fs-12'} />
                    </span>
                    <span className='heading'>
                        Add Professional Claim
                    </span>
                </li>
        },
        {
            name: 'Add Institutional Claim',
            elem:
                <li className='d-flex gap-2  align-items-center cursor-pointer px-10 py-2px selection-hover' onClick={() => handleObjData("Claims", "Institutional Claims")}>
                    <span className='icon'>
                        <IconClaimMenu classes={'fs-12'} />
                    </span>
                    <span className='heading'>
                        Add Institutional Claim
                    </span>
                </li>
        },
        {
            name: 'Add Insurance Payment',
            elem:
                <li className='d-flex gap-2  align-items-center cursor-pointer px-10 py-2px selection-hover' onClick={() => setAddNewInsurancePayment(true)}>
                    <span className='icon'>
                        <i className='icon-ins-payment fs-12 lh-11'></i>

                    </span>
                    <span className='heading'>
                        Add Insurance Payment
                    </span>
                </li>
        },
        ...(isHomeCareCheck === 'true' ? [] : [
            {
                name: 'Add Patient Payment',
                elem:
                    <li className='d-flex gap-2  align-items-center cursor-pointer px-10 py-2px selection-hover' onClick={() => openAddPatientPaymentPopup(true)}>
                        <span className='icon'>
                            <i className='icon-pat-payment fs-12 lh-11'></i>
                        </span>
                        <span className='heading'>
                            Add Patient Payment
                        </span>
                    </li>
            }]),
        {
            name: 'Add Task',
            elem:
                <li className='d-flex gap-2  align-items-center cursor-pointer px-10 py-2px selection-hover' onClick={() => handleOpenQuickPopup("Task")}>
                    <span className='icon'>
                        <i className="icon-Vector_task fs-11"></i>
                    </span>
                    <span className='heading'>
                        Add Task
                    </span>
                </li>
        },
        // {
        //     name: 'Add Alert',
        //     elem :
        //     <li className='d-flex gap-2  align-items-center cursor-pointer px-10 py-2px selection-hover' onClick={()=>{handleCreateAlert()}}>
        //         <span className='icon'>
        //             <i className='icon-alert'></i>
        //         </span>
        //         <span className='heading'>
        //             Add Alert
        //         </span>
        //     </li>
        // },
        {
            name: 'Add User',
            elem:
                <li className='d-flex gap-2  align-items-center cursor-pointer px-10 py-2px selection-hover' onClick={() => handleOpenQuickPopup("User")}>
                    <span className='icon'>
                        <i className='icon-single-patient fs-11'></i>
                    </span>
                    <span className='heading'>
                        Add User
                    </span>
                </li>
        },
        {
            name: 'Add Provider',
            elem:
                <li className='d-flex gap-2  align-items-center cursor-pointer px-10 py-2px selection-hover' onClick={() => handleOpenQuickPopup("ProviderFromQuickAdd")}>
                    <span className='icon'>
                        <i className='icon-single-patient fs-11'></i>
                    </span>
                    <span className='heading'>
                        Add Provider
                    </span>
                </li>
        },
        {
            name: 'Add Location',
            elem:
                <li className='d-flex gap-2  align-items-center cursor-pointer px-10 py-2px selection-hover' onClick={() => handleOpenQuickPopup("LocationFromQuickAdd")}>
                    <span className='icon'>
                        <i className='icon-Icon-material-location-on fs-12'></i>
                    </span>
                    <span className='heading'>
                        Add Location
                    </span>
                </li>
        },
        ...(isHomeCareCheck === 'true' ? [] : [
            {
                name: 'Instant Eligibility',
                elem:
                    <li className='d-flex gap-2  align-items-center cursor-pointer px-10 py-2px selection-hover' onClick={handleOpenInstantElibility}>
                        <span className='icon'>
                            <i className='icon-instant-eligibal fs-13'></i>
                        </span>
                        <span className='heading'>Instant Eligibility</span>
                    </li>
            }])
    ];
    const [menuButton, setMenuButton] = useState(false);
    const [searchText, setSearchText] = useState('')
    const [openTab, setOpenTab] = useState('');
    const [popup, setPopup] = useState('');
    // const [isOpenAlertType, setisOpenAlertType] = useState(false)

    const searchedData = useMemo(() => {
        return OPTIONS?.filter(item => item.name.toLowerCase().includes(searchText.toLowerCase()));
    }, [searchText, isHomeCareCheck])
    const handleObjData = (name, type) => {
        let data = {};
        if (type === 'Patient') {
            data = { id: -1, name: "New Patient" }
            dispatch(AddPatientToDropDowns({
                isDemographicsOpened: false,
                isDemographicsUpdated: false,
                isInsuranceOpened: false,
                isInsuranceUpdated: false,
                PatientID: -1,
            }));
        } else if (type === 'Professional Claims') {
            data = { name: "New Professional", id: -1, visitType: "P" }
        } else if (type === 'Institutional Claims') { data = { name: "New Institutional", id: -2, visitType: "I" } }
        // }else if(type==='Insurance Payment'){data={ id: -1,name: "New Insurance Payments",checkType:"Manual",paymentType:"Insurance"}}
        setOpenTab({
            key: 2,
            active: true,
            name: name,
            data: {
                time: new Date(),
                ...data
            },
        });
    }

    // const handleCreateAlert = () => {
    //     setisOpenAlertType(true);
    // };
    const closeDropdown = () => {
        setMenuButton(false)
    };
    // Function to handle opening a QuickPopup

    const handleOpenQuickPopup = (type, SelectedType) => {
        setPopup(<OpenQuickPopup ID={null} name={""} setPopup={setPopup} popupName={type} SelectedType={SelectedType || ''} type={'GlobalInstantSearch'} />);
    }
    ///////////////////////////////////////////////////////////
    ///////////Save Validation/////////////////////////////////
    ///////////////////////////////////////////////////////////
    const [addNewInsurancePayment, setAddNewInsurancePayment] = useState(false);
    const [addNewPatientPayment, setAddNewPatientPayment] = useState(false);

    const openAddPatientPaymentPopup = () => {
        setAddNewPatientPayment(true);
    }
    const OnCloseAddInsurancePaymentPopup = () => {
        setAddNewPatientPayment(false);
    }
    let PtPaymentPopup = '';
    if (addNewPatientPayment) {
        PtPaymentPopup = <PatientPayments isOpenPatientPayments={addNewPatientPayment} OnClosePtPayment={OnCloseAddInsurancePaymentPopup} PatientID='' type={'Payment'} ID={'0'} />
    }

    // const handleCalendarChange = (date, name, type) => {
    //     var FormatedDate = date
    //     let modal = { ...data[type] };
    //     modal[name] = FormatedDate
    //     handleChange({ [type]: modal })
    // }
    // const handleInputChange = (e, type) => {
    //     let { name, value } = e.target;
    //     let modal = { ...data[type] };
    //     modal[name] = value
    //     handleChange({ [type]: modal })
    // }
    // const API_URL_GENERAL = enumUtil.controller.General
    // let Search_Value = {
    //     InsuranceName: "",
    // }
    // const [isLoading, setIsLoading] = useState(false)
    // const [searchValue, setSearchValue] = useState(Search_Value);
    // const [insuranceBody, setinsuranceBody] = useState({
    //     "TableName": enumUtil.enumAPITableName.Insurance,
    //     "SearchParam": '',
    // });
    // const [is, setIs] = useState(false);
    // let Header_Data = {
    //     BPR_02_CheckAmount: null,
    //     BPR_16_CheckDate: null,
    //     DepositDate: null,
    //     TRNCheckNumber: '',
    //     InsuranceID: '',
    //     PostingStatus: '',
    //     SenderBankAccount: '',
    //     ReceiverBankAccount: '',
    // }
    // const [data, handleChange] = useReducer((prev, next) => {
    //     return { ...prev, ...next }
    // }, { HeaderData: Header_Data })


    ///////////Save Validation/////////////
    // let saveValModal = {}
    // let SaveValidationModal = {
    //     // PaymentTypeVal: "",
    //     TRNCheckNumberVal: "",
    //     BPR_16_CheckDateVal: "",
    //     BPR_02_CheckAmountVal: "",
    //     PayerIDVal: "",
    // };
    // const [saveValidationModal, setSaveValidationModal] = useState(SaveValidationModal);
    // const SaveValidation = async () => {
    //     const checkExists = await handleValidateCheckNumber(true); // Await the result
    //     let SaveValidationModal = {
    //         PayerIDVal: FormValidator(
    //             searchValue.InsuranceName,
    //             enumUtil.enumValidationType.Required,
    //             'Payer',
    //         ),
    //         TRNCheckNumberVal: checkExists ?
    //             <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
    //                 <i className="bi bi-info-circle-fill fs-10"></i>
    //                 <p className="fs-9 text-white text">Check with this number already exists</p>
    //             </div> : FormValidator(
    //                 data.HeaderData.TRNCheckNumber,
    //                 enumUtil.enumValidationType.Required,
    //                 'Check Number',
    //             ),
    //         BPR_16_CheckDateVal: FormValidator(
    //             data.HeaderData.BPR_16_CheckDate,
    //             enumUtil.enumValidationType.Required,
    //             'Check Date',
    //         ),
    //         BPR_02_CheckAmountVal: FormValidator(
    //             data.HeaderData.BPR_02_CheckAmount,
    //             enumUtil.enumValidationType.Required,
    //             'Check Amount',
    //         ),

    //     }
    //     await setSaveValidationModal(SaveValidationModal)
    //     saveValModal = SaveValidationModal
    // }
    // const CheckExistsValidation = async (exists) => {
    //     let SaveValidationModal = {
    //         ...saveValidationModal,
    //         TRNCheckNumberVal: exists ?
    //             <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
    //                 <i className="bi bi-info-circle-fill fs-10"></i>
    //                 <p className="fs-9 text-white text">Check with this number already exists</p>
    //             </div> : FormValidator(
    //                 data.HeaderData.TRNCheckNumber,
    //                 enumUtil.enumValidationType.Required,
    //                 'Check Number',
    //             ),

    //     }
    //     await setSaveValidationModal(SaveValidationModal)
    //     saveValModal = SaveValidationModal
    // }
    // const handleValidateCheckNumber = async (isReturn) => {
    //     try {
    //         const response = await ServerRequestProtected(API_URL + "/ValidateCheckNo", 'post', {
    //             "TableName": enumUtil.enumAPITableName.CheckDetails,
    //             "SearchParam": data.HeaderData.TRNCheckNumber,
    //         });

    //         if (response === "Check with this number already exists") {
    //             console.log("isReturn", isReturn);
    //             if (isReturn === true) return true;
    //             CheckExistsValidation(true);
    //             return true; // Ensure we return true for this case
    //         } else {
    //             if (isReturn === true) return false;
    //             CheckExistsValidation(false);
    //             return false; // Ensure we return false for this case
    //         }
    //     } catch (error) {
    //         console.error("Error validating check number:", error);
    //         if (isReturn === true) return false; // Default return on error
    //         setIsLoading(false);
    //         return false; // Ensure we return false on error
    //     }
    // };

    // const handleSaveHeaderData = (response) => {
    //     response['ID'] = response.id;
    //     response['CheckNumber'] = data.HeaderData.TRNCheckNumber;
    //     response['Type'] = 'Manual';
    //     OpenPayments(response);
    //     setAddNewInsurancePayment(false);
    //     handleChange({ 'HeaderData': Header_Data })
    //     setSearchValue(Search_Value)
    // }
    // const OpenPayments = (data) => {
    //     let obj = {
    //         key: 2,
    //         name: "Payments",
    //         active: true,
    //         data: {
    //             id: data.ID,
    //             name: data.CheckNumber,
    //             time: new Date(),
    //             checkType: data.Type,
    //             // checkTypeCategory: data.Type,
    //         },
    //     };
    //     TabActionPayments(obj);
    // }
    /////////////////////////////////////////
    // const handleSaveModal = () => {
    //     const modal = {
    //         "Header": {
    //             "ID": "0",
    //             "data": data.HeaderData
    //         },
    //     };
    //     return modal;
    // }
    // const AddManualPayment = (type) => {
    //     if (type === 'Insurance') {
    //         handleSave();
    //     }
    //     else if (type === 'Patient') { }
    // }
    // const AddNewPatientPayment = (data) => {
    //     handleSave('Patient');
    //     // data ? AddNewPayments('Patient',data) : AddNewPayments('Patient');
    //     // setAddNewInsurancePayment(false);
    // }
    // const handleSave = async () => {
    //     await SaveValidation();
    //     let saveValidation = FormValidator([saveValModal], enumUtil.enumValidationType.NullCheck)
    //     if (saveValidation) {
    //         NotificationHandler('Fill required Data', enumUtil.enumtoaster.error)
    //         return
    //     } else {
    //         let modal = handleSaveModal();
    //         setIsLoading(true);
    //         ServerRequestProtected(API_URL_GENERAL + "/SaveManualPosting", 'post', {
    //             ...modal
    //         })
    //             .then((response) => {
    //                 setIsLoading(false);
    //                 NotificationHandler("Record Saved", enumUtil.enumtoaster.success);
    //                 if (response.id) {
    //                     handleSaveHeaderData(response);
    //                 }
    //             }).catch((error) => {
    //                 setIsLoading(false);
    //                 NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
    //             })
    //     }
    // }
    // const addHeader = (name) => {
    //     return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '12px' }}>{`Add ${name} Payment`}</p>;
    // };
    // const handleSearchChange = (e) => {
    //     setIs(false);
    //     let { name, value } = e.target;
    //     if (name === "InsuranceID") {
    //         setSearchValue({ ...searchValue, InsuranceName: value });
    //     }
    //     if (!isNull(value)) {
    //         setinsuranceBody({ "TableName": enumUtil.enumAPITableName.Insurance, "SearchParam": value })
    //     }
    // };

    // const handleSelectedData = (selectedData, name, type) => {
    //     setIs(true);
    //     if (!isNull(selectedData)) {
    //         if (type === "client") {
    //             if (name === "InsuranceID" && !isNull(selectedData)) {
    //                 setSearchValue({ ...searchValue, InsuranceName: selectedData.display });
    //                 let modal = { ...data['HeaderData'] };
    //                 modal[name] = selectedData.value.toString()
    //                 handleChange({ 'HeaderData': modal })
    //             }
    //         } else if (type === "server") {
    //             if (name === "InsuranceID") {
    //                 setSearchValue({ ...searchValue, InsuranceName: selectedData.display });
    //                 let modal = { ...data['HeaderData'] };
    //                 modal[name] = selectedData.value.toString()
    //                 handleChange({ 'HeaderData': modal })
    //             }
    //         }
    //     } else {
    //         if (name === "InsuranceID") {
    //             setSearchValue({ ...searchValue, InsuranceName: '' })
    //             let modal = { ...data['HeaderData'] };
    //             modal[name] = ''
    //             handleChange({ 'HeaderData': modal })
    //         }
    //     }
    //     return selectedData;
    // };
    const handleSubMenu = (e) => {
        setMenuButton(!menuButton)
        e.stopPropagation();
    }
    //////Open Encounter ///////
    const aiSession = useSelector(state => state.ResumeAISessionReducer);
    let recordingInProgressData = useSelector(state => state.Open_EncounterMenu_Tab).find(enc => enc.data.id === aiSession?.activeRecordingEncounterId)?.data ?? null //object details 
    let dispatch = useDispatch()
    let state = useSelector(state => state.SidebarList)
    const handleActive_SubTab = (key, name, component, right) => {
        let arr = state
        let dynamicTabs = [...arr]
        const newTabObject = {
            key: key,
            name: name,
            component: component,
            right: right,
            time: new Date(),
        }
        const isTabExist = dynamicTabs.filter((tab) => {
            return tab.name === name
        })
        if (!(isTabExist && isTabExist.length > 0)) {
            dynamicTabs = [...dynamicTabs, newTabObject]
            dispatch(MainTabContentTabList(dynamicTabs));
        }
        dispatch(MainTabContentActiveTab(key))
    }


    const resumeRecording = (data) => {
        if (!data) return;

        handleActive_SubTab(9, 'Encounters', <EncounterMenu />, true)
        let obj = {
            active: true,
            key: 2,
            name: "Encounter Menu",
            data: {
                name: data?.name,
                id: data?.id,
                patid: data?.patid,
                type: data?.type,
                time: new Date(),
                groupEncounter: {
                    isGroupEncounter: data?.groupEncounter?.isGroupEncounter,
                    GroupIdentifier: data?.groupEncounter?.GroupIdentifier,
                    showGroupNote: data?.groupEncounter?.showGroupNote
                },
            },
        }
        setTimeout(() => {
            dispatch({ type: "OPEN_AI_POPUP", payload: { openAIPopup: true } }); // to open ai popup
            dispatch(TabActionEncounterMenu(obj))
        }, 0);
    }
    // console.log("aiSession", aiSession)
    return (<>
        {/* <Addalert isOpenAlertType={isOpenAlertType} onClose={() => setisOpenAlertType(false)} loadAlertData={null} type={'Payment'} /> */}
        {/* Manual Check */}
        <AddNewInsurancePayment addNewInsurancePayment={addNewInsurancePayment} setAddNewInsurancePayment={setAddNewInsurancePayment} />
        {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : <></>}
        {popup}
        {PtPaymentPopup}
        {InstantEligibilityPopup}
        <div className="d-flex align-items-center gap-12">
            {recordingInProgressData &&
                <NavbarAIRecordingIndicator aiSession={aiSession} data={recordingInProgressData} resumeRecording={resumeRecording} />}
            {/* icon */}
            <div className="alert-icon session-btn app_tooltip bottom" onClick={handleSubMenu}>
                <i className="icon-plus-icon mt-1"></i>
                <p class="tool_tip xsm_text text-light">Add</p>
            </div>
        </div>
        {/* list  */}
        {<CustomUseRef onClose={closeDropdown} IsActivePtPayments={menuButton} type={'menuButton'}>
            <div className='menu_buttons  px-0 pt-0'>
                <div className='br-bottom-1 br-clr'>
                    <div className='ar-input'>
                        <input
                            type="text"
                            className="form-control w-100"
                            name="AllocateAmount"
                            id="AllocateAmount"
                            variant="outlined"
                            placeholder='Search..'
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                        <i className='icon-Clip-path-group'></i>
                    </div>
                </div>

                <ul className='menu_list pt-1 px-0 d-flex flex-column gap-1'>
                    {searchedData?.map(item => (item.elem))}
                </ul>
            </div>
        </CustomUseRef>}
        {/* <Modal show={addNewInsurancePayment} onHide={addNewInsurancePayment} backdrop="static" keyboard={false} dialogClassName="app-modal hk-modal-v1 modal-lg add_insurance_modal">
            <Modal.Body>
                <ModalHeader DeletePopup={""} HeaderName={() => addHeader('Insurance')} isClosed={() => {
                    setAddNewInsurancePayment(false); setSaveValidationModal(SaveValidationModal);
                }} key={631} Name={'AddInsurancePayment'} />
                <div className="add_insurance_modal old-validation-design">
                    <div className={` input ${saveValidationModal.TRNCheckNumberVal ? "error" : ""}`}>
                        <label >Check #<span className='req'>*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            id="TRNCheckNumber"
                            name="TRNCheckNumber"
                            value={data.HeaderData.TRNCheckNumber}
                            onChange={(e) => handleInputChange(e, 'HeaderData')}
                            onBlur={handleValidateCheckNumber}
                        />
                        {saveValidationModal.TRNCheckNumberVal}
                    </div>
                    <div className={` input ${saveValidationModal.BPR_16_CheckDateVal ? "error" : ""}`}>
                        <DatePicker
                            label={<>Check Date<span className='req'>*</span></>}
                            className={`${saveValidationModal.BPR_16_CheckDateVal ? "mb-0" : ""}`}
                            value={data.HeaderData.BPR_16_CheckDate}
                            maxDate={new Date()}
                            handleCalendarChangefunc={(e) => handleCalendarChange(e, 'BPR_16_CheckDate', 'HeaderData')}
                        />
                        {saveValidationModal.BPR_16_CheckDateVal}
                    </div>
                    <div className={`input ${saveValidationModal.BPR_02_CheckAmountVal ? "error" : ""}`}>
                        <label className="">Check Amount<span className='req'>*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            id="BPR_02_CheckAmount"
                            name="BPR_02_CheckAmount"
                            value={data.HeaderData.BPR_02_CheckAmount}
                            onChange={(e) => handleInputChange(e, 'HeaderData')}
                            onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                        />
                        {saveValidationModal.BPR_02_CheckAmountVal}
                    </div>
                    <div className={`d-flex flex-column input ${saveValidationModal.PayerIDVal ? "error" : ""}`}>
                        <label className="">Payer<span className='req'>*</span></label>
                        <SuperSearchList
                            type="client"
                            id="InsuranceID"
                            name="InsuranceID"
                            searchValue={searchValue.InsuranceName}
                            data={DropDowns.Insurance?.filter(item => !['-1', -1, "SELFPAY"].includes(item.value))}
                            onChange={handleSearchChange}
                            getSelectedData={handleSelectedData}
                            is={is}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                            // isReadOnly={isReadOnly}
                            placeholder={false}
                            inputError={saveValidationModal.PayerIDVal}
                        />
                        {saveValidationModal.PayerIDVal}
                    </div>
                    <div className="input">
                        <DatePicker
                            label='Deposit Date'
                            value={data.HeaderData.DepositDate}
                            maxDate={new Date()}
                            handleCalendarChangefunc={(e) => handleCalendarChange(e, 'DepositDate', 'HeaderData')} />
                    </div>
                    <div className="input">
                        <label className="">Sender Bank Account #</label>
                        <input
                            type="text"
                            className="form-control py-0"
                            id="SenderBankAccount"
                            name="SenderBankAccount"
                            value={data.HeaderData.SenderBankAccount}
                            onChange={(e) => handleInputChange(e, 'HeaderData')}
                            onKeyPress={(event) => handleNumericCheck(event)}
                        />
                    </div>
                    <div className="input">
                        <label className="">Receiver Bank Account #</label>
                        <input
                            type="text"
                            className="form-control py-0"
                            id="ReceiverBankAccount"
                            name="ReceiverBankAccount"
                            value={data.HeaderData.ReceiverBankAccount}
                            onChange={(e) => handleInputChange(e, 'HeaderData')}
                            onKeyPress={(event) => handleNumericCheck(event)}
                        />
                    </div>
                </div>
                <div className="tabs-action-bottom">
                    <div className="btns-group text-end pt-2 br-top-1 br-clr d-flex align-items-center justify-content-end h-100">
                        <button className={IsEditAllowedInurancePayment ? "btn btn-orange p-1 d-flex align-items-center justify-content-center gap-01" : "btn btn-orange disabled"} onClick={() => AddManualPayment('Insurance')}>Proceed <i className="icon-arrow-right2"></i></button>
                    </div>
                </div>
            </Modal.Body>
        </Modal> */}
    </>);
}

export default QuickAddMenu;

const NavbarAIRecordingIndicator = ({ aiSession, data, resumeRecording }) => {
    //   const { activeRecordingEncounterId, recordingStartedAt, recordingStatus, pausedAt, accumulatedPausedMs } =
    //     aiSession;
    const { activeRecordingEncounterId, duration } = aiSession;
    const [elapsedSec, setElapsedSec] = useState(0);


    const formatTime = (sec) => {
        const m = String(Math.floor(sec / 60)).padStart(2, "0");
        const s = String(sec % 60).padStart(2, "0");
        return `${m}:${s}`;
    };

    if (!activeRecordingEncounterId) return null;
    return (
        <div className="Resume-Ai-Button d-flex align-items-center gap-6 cursor-pointer user-select-none" onClick={() => resumeRecording(data)}>
            <IconResumeAiSession />
            <p className="text text-white fs-11 font-m">{formatTime(duration)}</p>
        </div>
    );
}